import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';

import { HighlightedCollectionType } from '../../../core/enums/highlighted-collection-type.enum';
import { OrderMenuItemSourceType } from '../../../core/enums/order-menu-item-source-type.enum';

import { HighlightedCollection } from '../../../core/models/highlighted-collection.model';

import { SettingsService } from '../../../core/services/settings.service';
import { PlatformService } from '../../../core/services/ssr/platform.service';

import SwiperCore, { Navigation, SwiperOptions } from 'swiper';
import { SwiperComponent } from 'swiper/angular';

SwiperCore.use([Navigation]);

@Component({
  selector: 'app-featured-collection-horizontal-list',
  templateUrl: './featured-collection-horizontal-list.component.html',
  styleUrls: ['./featured-collection-horizontal-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class FeaturedCollectionHorizontalListComponent implements OnInit {
  @ViewChild('scrollElement', { read: ElementRef })
  public scrollElement?: ElementRef<HTMLElement>;

  @Input()
  public collection: HighlightedCollection;

  @Input()
  public collectionIndex?: number;

  @Output()
  private addNewWishlist = new EventEmitter<void>();

  @ViewChild('swiper')
  private swiper?: SwiperComponent;

  public isBrowser: boolean;

  public sliderScrollingDirection: string;
  public sliderConfig: SwiperOptions;

  public HighlightedCollectionType = HighlightedCollectionType;

  public reorderSourceType = OrderMenuItemSourceType.ReOrder;
  public featuredItemSourceType = OrderMenuItemSourceType.FeaturedMenuItem;
  public sponsoredVendorSourceType = OrderMenuItemSourceType.SponseredVendor;

  constructor(private settingsService: SettingsService, private platformService: PlatformService) {}

  ngOnInit() {
    this.isBrowser = this.platformService.isBrowser;
    this.sliderScrollingDirection = this.settingsService.getLanguageDirection();
    this.sliderConfig = {
      slidesPerView: 'auto',
      spaceBetween: 16,
      freeMode: true,
      navigation: {
        nextEl: `#next-${this.collectionIndex}`,
        prevEl: `#prev-${this.collectionIndex}`,
      },
    };
  }

  public onAddNewWishlist(): void {
    this.addNewWishlist.emit();
  }

  public getScrollElement(): HTMLElement {
    return (this.isBrowser ? this.swiper?.swiperRef?.el : this.scrollElement?.nativeElement) || undefined;
  }

  public resetHorizontalScroll(): void {
    if (this.isBrowser) {
      this.swiper?.swiperRef?.slideTo(0);
      return;
    }

    const targetElement = this.scrollElement?.nativeElement;
    if (targetElement) {
      targetElement.scrollLeft = 0;
    }
  }
}
